var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStatus),expression:"showStatus"}],staticClass:"bv-layer-container",class:{'no-tab-bar':!_vm.view.tabBar},on:{"click":function($event){$event.stopPropagation();return _vm.click.apply(null, arguments)}}},[_c('div',{staticClass:"bv-layer"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }